import express, { NextFunction, Request, Response } from "express"
import dotenv from "dotenv"
import bodyParser from "body-parser"
import helmet from "helmet"
import cors from "cors"

import { routeGetOnline } from "./routes/online.js"
import { routeAuthPost } from "./routes/auth.js"
import { routeTokenCheck } from "./routes/token-check.js"
import { routeGetUsers } from "./routes/users.js"

// needed to read the proper .env file, even when index.ts has it
dotenv.config()

const app = express()
const portnum = process.env.port ?? 9999
const isProduction = !!process.env.core_db_socket_path

// has to come before everything else
if (!isProduction) {
	console.log(`Development mode: Using CORS via Express`)
	app.use(cors())
} else {
	console.log(`Production mode: CORS should be handled by Apache reverse proxy`)
}
app.use(express.json())

// adding Helmet to enhance your API's security
app.use(helmet())

// using bodyParser to parse JSON bodies into JS objects
app.use(bodyParser.json())

app.get("/", routeGetOnline)
app.get("/users", routeGetUsers)
app.post("/auth", routeAuthPost)
app.post("/token-check", routeTokenCheck)

app.use((err: any, _req: Request, res: Response, _next: NextFunction) => {
	const statusCode = err.statusCode || 500
	console.error(err.message, err.stack)

	res.status(statusCode).json({ message: err.message })
})

app.listen(portnum, (err) => {
	const path = isProduction ? `https://core-api.jba3.com` : `http://localhost`

	if (isProduction) {
		console.log(`Using socket path: ${process.env.core_db_socket_path}`)
	}

	console.log(`CORE-API.JBA3.COM is running at: ${path}:${portnum}/`)

	if (err) {
		console.log(err)
	}
})
